export const NUMBER_REGEXP = /^\d+$/

export const THREE_DECIMAL_NUMBER_REGEXP = /^[0-9]{1,6}(\.[0-9]{0,3})?$/
